import RectangleImageButton from 'components/atoms/rectangleImageButton';
import BlindToSwipe from 'components/molecules/blindToSwipe';
import ChatTextInput from 'components/molecules/chatTextInput';
import Message from 'components/molecules/message';
import {useTheme} from 'contexts/ThemeContext';
import {IMessage} from 'models/chat';
import React, {useEffect, useState} from 'react';
import {
  FlatList,
  Keyboard,
  KeyboardAvoidingView,
  ListRenderItemInfo,
  Platform,
  SafeAreaView,
  Text,
  View,
} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ChatListProps {
  message: string;
  chatMessages: IMessage[];
  setMessage: (message: string) => void;
  onPressSend: () => void;
}

const ChatList = (props: ChatListProps) => {
  const valueToClose = -30;
  const iosKeyboardOffset = 100;

  const theme = useTheme();
  const styles = styleSheet(theme);

  const [isTextFieldFocused, setIsTextFieldFocused] = useState(false);

  const onFocus = () => {
    setIsTextFieldFocused(true);
  };

  const onBlur = () => {
    setIsTextFieldFocused(false);
  };

  const onResponderMove = (value: number) => {
    if (value < valueToClose) {
      Keyboard.dismiss();
    }
  };

  const renderItem = (itemProps: ListRenderItemInfo<IMessage>) => {
    return (
      <Message
        name={itemProps.item.user.name}
        isMyMessage={itemProps.item.isMyMessage}
        message={itemProps.item.text}
        time={itemProps.item.createdAt}
      />
    );
  };

  const BottomView = (
    <View style={styles.composerContainer}>
      {isTextFieldFocused && Platform.OS !== 'web' && (
        <BlindToSwipe onResponderMove={onResponderMove} />
      )}
      <View style={styles.bottomViewContainer}>
        <ChatTextInput
          onFocus={onFocus}
          onBlur={onBlur}
          text={props.message}
          onChangeText={props.setMessage}
        />
        <View style={styles.bottomSpacer} />
        <RectangleImageButton
          image={theme.images.sent}
          onPress={props.onPressSend}
        />
      </View>
    </View>
  );

  const ChatTitle = <Text style={styles.chatTitle}>{strings.chat.title}</Text>;

  return (
    <SafeAreaView style={styles.safeAreaContainer}>
      <KeyboardAvoidingView
        behavior="padding"
        enabled={true}
        keyboardVerticalOffset={Platform.OS === 'ios' ? iosKeyboardOffset : 0}
        style={styles.container}>
        <View style={styles.container}>
          {theme.isWebSize && ChatTitle}
          <FlatList
            style={styles.flatList}
            inverted
            renderItem={renderItem}
            data={props.chatMessages}
          />
          {BottomView}
        </View>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

export default ChatList;
